var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-card"},[_c('div',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("\n      "+_vm._s(_vm.$t("Language"))+"\n    ")])]),_c('div',{staticClass:"modal-card-body"},[_vm._v("\n    \n      "+_vm._s(_vm.$i18n.locale)+"\n      "+_vm._s(_vm.languages)+"\n      ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }